const createLinkElement = (url: string) => {
  const element = document.createElement('link');

  element.rel = 'stylesheet';
  element.href = url;
  document.head.appendChild(element);
};

const createFontLinkElement = (urls: string[]) => {
  if (urls.length) {
    urls.forEach((url: string) => createLinkElement(url));
  }
};

export default createFontLinkElement;
